import { getChainKey, isSupportedChainId } from '@silo/types';
import { AccountDetailsTransaction, ConnectWallet } from '@silo/ui';
import { getSupportedWalletFromWalletKey, connectWallet as baseConnectWallet, Transaction } from '@silo/web3';

export const connectWallet: ConnectWallet = (walletKey, previousWalletKey) => {
  const wallet = getSupportedWalletFromWalletKey(walletKey);
  const previousWallet = previousWalletKey ? getSupportedWalletFromWalletKey(previousWalletKey) : undefined;

  return baseConnectWallet({ wallet, previousWallet });
};

export function mapTransactions(transactions: Transaction[]): AccountDetailsTransaction[] {
  return transactions.flatMap((transaction): AccountDetailsTransaction[] => {
    const { chainId, message, status, tx } = transaction;

    if (!isSupportedChainId(chainId)) {
      return [];
    }

    const chainKey = getChainKey(chainId);

    return [
      {
        chainKey,
        message,
        status,
        txHash: tx.hash,
      },
    ];
  });
}
